import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';

import { loadCatalogProducts, setProductsRequestReadyToSwitch } from 'store/ProductCatalog/actions';
import { getCatalogProductsRequestStatus } from 'store/ProductCatalog/products/selectors';
import { REQUEST_INPROGRESS } from 'store/constants';
import { SmoothContentSwitcher } from 'bricks';
import { DeviceButton } from 'pages/ProductCatalog/components/ProductCollectionWidget/components/DeviceButton';

import { DeviceList } from './components/DeviceList';

const ProductCollectionLayout = ({ children, onReadyToSwitch, isLoading /* , isTiled, */ }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadCatalogProducts());
  }, []);

  return (
    <SmoothContentSwitcher isLoading={isLoading} onReadyToSwitch={onReadyToSwitch}>
      <DeviceList />
      <DeviceButton />
      {children}
    </SmoothContentSwitcher>
  );
};

ProductCollectionLayout.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  onReadyToSwitch: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isLoading: getCatalogProductsRequestStatus(state) === REQUEST_INPROGRESS,
});

const mapDispatchToProps = {
  onReadyToSwitch: setProductsRequestReadyToSwitch,
};

const ProductCollectionWidget = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductCollectionLayout);
export default ProductCollectionWidget;
